import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../environments/environment';

export type SubscriptionPlan = 'basic' | 'premium';
export interface EmbeddedCheckoutSession {
  clientSecret: string;
  publishableKey: string;
}

@Injectable({ providedIn: 'root' })
export class SubscriptionService {
  private readonly http = inject(HttpClient);

  createCheckout(plan: SubscriptionPlan, trial: boolean): Promise<EmbeddedCheckoutSession> {
    return firstValueFrom(
      this.http.post<EmbeddedCheckoutSession>(`${environment.apiUrl}/subscriptions/checkout-session`, { plan, trial })
    );
  }
}
